import { safeJsonParse } from "common/utilities/safeJsonParse";
import type { UserRole } from "entities/permissions/constants";
import type { RootState } from "types/redux";

export const getIdToken = (state: RootState) => state.domains.authentication.idToken;

export const getIsAuthenticated = (state: RootState) => getIdToken(state) !== undefined;

export const getUserId = (state: RootState) => {
  const token = getIdToken(state);
  return token === undefined ? undefined : decodeIdToken(token)?.sub;
};

export const getUserRole = (state: RootState) => {
  const token = getIdToken(state);
  return (token === undefined ? undefined : decodeIdToken(token)?.user.si_subscription_level) ?? "Unauthenticated";
};

type IdToken = { sub: string; user: { si_subscription_level: UserRole } };

const decodeIdToken = (token: string) => {
  const result = safeJsonParse(atob(token.split(".")[1]));
  return result === undefined ? undefined : (result.value as IdToken);
};
